// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"78848f94","260":"94b1aa2c","295":"7afaa27a","653":"390113dc","787":"aeb39de0","889":"a5941d14"}[chunkId] + ".chunk.js";
};